import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';

/** Start of the current day. Rolls over at midnight while the page stays open. */
export function useToday(): DateTime {
  const [today, setToday] = useState(getToday);

  useEffect(() => {
    const timer = setTimeout(() => setToday(getToday()), getMsUntilTomorrow());
    return () => clearTimeout(timer);
  }, [today]);

  // The timer doesn't run while a laptop sleeps or a webview is backgrounded.
  useEffect(() => {
    function refresh() {
      const next = getToday();
      setToday((current) => (current.equals(next) ? current : next));
    }

    document.addEventListener('visibilitychange', refresh);
    return () => document.removeEventListener('visibilitychange', refresh);
  }, []);

  return today;
}

function getToday() {
  return DateTime.local().startOf('day');
}

function getMsUntilTomorrow() {
  const now = DateTime.local();
  return now.plus({ days: 1 }).startOf('day').diff(now).toMillis();
}
